import config from 'app/config';
import { KameProgram } from './types';
import { graphqlQuery } from 'utils/graphqlQuery';

const query = `
query {
    programs {
        id,
        companyId,
        name,
        status,
        activities {
            id,
            active,
            name,
            type,
            visibility,
        },
        rewardDistributions {
            id,
            rosterGroups {
                groupId,
            },
            recognitionDistribution {
                recognitionDistributionId,
                method,
                roomId,
                activity {
                    id,
                    active,
                    name,
                    type,
                    visibility,
                },
                rewards {
                    id,
                    type,
                    taxable,
                    points {
                        pointsType,
                        minValue,
                        maxValue
                    }
                },
            },
        }
    }
}
`;

export const getPrograms = async (): Promise<KameProgram[]> =>
    graphqlQuery<KameProgram[]>(config.KAME_API_URL, query);
